<template>
    <el-dialog title="同步至数字校园" :visible="isShow" :before-close="handleClose" width="50%">
        <el-alert
                title="温馨提示: 由于数字校园有独立的账号体系，对于需要添加至数字校园的其他产品账号可以使用该功能同步至数字校园"
                type="success">
        </el-alert>
        <el-table v-loading="loading" :data="details" style="width: 100%" height="400">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="ID" prop="user_id"></el-table-column>
            <el-table-column label="用户名" prop="username"></el-table-column>
            <el-table-column label="真实姓名" prop="real_name"></el-table-column>
            <el-table-column label="身份" prop="identity_name"></el-table-column>
            <el-table-column align="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="removeRow(scope.row)">移除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="save" :loading="submiting">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import AccountService from "~/services/CustomerAccounts";
    export default {
        name: "CopyToSzxy",
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            accounts: {
                type: Array,
                default: [],
                required: true
            },
            display: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isShow: false,
                details: [],
                loading: false,
                submiting: false
            }
        },
        created() {
            this.isShow = this.display;
            if (this.accounts.length > 0 && this.details.length == 0) {
                this.getDetails();
            }
        },
        methods: {
            getDetails() {
                this.loading = true;
                AccountService.getDetails(this.accounts).then(res => {
                    if (res.code == 0) {
                        this.details = res.data;
                    }
                    this.loading = false;
                }).catch(err => {
                    console.error(err)
                    this.loading = false;
                })
            },

            close(status = false) {
                this.showImport = false;
                this.showForm = false;
                this.accounts = [];
                this.$emit("callback", status);
            },

            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            close(status = false) {
                this.isShow = false;
                this.submiting = false;
                this.details = [];
                this.$emit("callback", status);
            },

            removeRow(row) {
                this.$confirm("确定要移除改条记录？", "温馨提示", {type: "warning"}).then(ok => {
                    this.details.splice(this.details.indexOf(row), 1);
                }).catch(cancel => {
                    return false;
                });
            },

            save() {

                this.submiting = true;

                if (this.accounts.length < 1) {
                    this.$message.error("没有可用的数据");
                    return false;
                }

                AccountService.syncSzxy(this.accounts).then(res => {
                    this.submiting = false;
                    if (res.code == 0) {
                        this.$message.success("同步成功!");
                        this.close(true);
                    }
                }).catch(err => {
                    console.error(err);
                    this.submiting = false;
                })

            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/dialog/CopyToSzxy.vue